import { render, staticRenderFns } from "./another_tab.vue?vue&type=template&id=624e07b6&scoped=true&"
import script from "./another_tab.vue?vue&type=script&lang=js&"
export * from "./another_tab.vue?vue&type=script&lang=js&"
import style0 from "./another_tab.vue?vue&type=style&index=0&id=624e07b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e07b6",
  null
  
)

export default component.exports